import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import config from '../../api/params.config';
import axios from 'axios';
// 声明变量
// declare const a: any;

@Component({})
export default class Login extends Vue {
  private $api: any;
  private $reg: any;
  private $cookie: any;
  // 变量（可根据定义变量为public/private/protected/null）
  // data
  private code: any;
  private username: string = '';
  private password: string = '';
  private sms: string = '';
  private isRemember: boolean = false;

  constructor() {
    super();
  }

  // methods
  private login() {
    if (this.username.replace(/ /g, '').length === 0) {
      this.$toast('请输入用户名！');
      return;
    }
    if (!this.$reg.isUserName(this.username)) {
      this.$toast('用户名格式不正确！');
      return;
    }
    if (this.password.replace(/ /g, '').length === 0) {
      this.$toast('请输入密码！');
      return;
    }
    if (this.isRemember) {
      window.localStorage.setItem('userInfo', JSON.stringify({name: this.username, pasd: this.password}));
    } else {
      window.localStorage.removeItem('userInfo');
    }
    this.postData();
  }

  private async reset() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
    });
    axios({
      method: 'POST',
      url: '/WeChat/ClearBind',
      params: {
        code: this.username,
      },
      withCredentials: false,
      baseURL: 'http://ehr-wechat.lunztech.cn',
    })
    .then( (DATA: any) => {
      this.$toast.clear();
      if (DATA.Success) {
        this.$dialog.alert({
          message: '登录成功！',
        }).then(() => {
          // log
        });
      } else {
        this.$dialog.alert({
          message: DATA.AllMessages,
        });
      }
    });
  }

  // computed
  get openId() {
    return this.$store.state.openId;
  }

  set openId(value) {
    this.$store.commit('changeValue', value);
  }

  get computedMsg() {
    return `用户名是${this.username}`;
  }

  // life cycle
  private async created() {
    // 需要去验证身份,判断是否存在code
    // if (this.$route.query.code === undefined || this.$route.query.code === null || this.$route.query.code === '') {
    //   // 路由名需要动态配置（个人感觉可进行封装）
    //   const url = '';
    //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.WECHAT_APPID + '&redirect_uri=http://ehr-wechat.lunztech.cn/#/' + url + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
    // } else {
    //   // 调用接口获取accessToken
    //   const param = {
    //     // 直接从cookie中拾取
    //     authToken: this.$cookie.get('AUTHTOKEN'),
    //     sCorpID: config.WECHAT_APPID,
    //     // 需要配置到config中，此处暂时写死
    //     appId: '2',
    //   };
    //   // 获取accessToken
    //   this.$api.handleGet('WeChatInterface/WeChatInterface/GetAccessToken', param, (result: any) => {
    //     if (result.Success) {
    //       // 获取code
    //       const params = {
    //         authToken: this.$cookie.get('AUTHTOKEN'),
    //         accessToken: result.Data,
    //         code: this.$route.query.code ? this.$route.query.code : '',
    //       };
    //       // 获取codeID
    //       this.$api.handleGet('WeChatInterface/WeChatInterface/GetCode', params, (response: any) => {
    //         if (response.Success) {
    //           // 企业成员
    //           if (response.errcode === 0 && response.UserId) {
    //             // to do
    //             // 验证是否已经绑定，如果绑定则模拟登录
    //           }
    //           return;
    //         }
    //       }, (error: any) => {
    //         // to do
    //       });
    //     }
    //   }, (error: any) => {
    //     // to do
    //   });
    // }
    // 本地存储
    const INFO = window.localStorage.getItem('userInfo');
    if (INFO) {
      this.username = JSON.parse(INFO).name;
      this.password = JSON.parse(INFO).pasd;
      this.isRemember = true;
    }
  }

  // methods
  private async postData() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
    });
    const PARAMS = {
      UserName: this.username,
      Password: this.password,
      Remember: this.isRemember,
    };
    const DATA = await this.$api.httpPost('Membership/Membership/Login', PARAMS);
    this.$toast.clear();
    if (DATA.Success) {
      this.$cookie.set('AUTHTOKEN', DATA.Data, 2);
      this.$cookie.set('CURAUTHTOKEN', DATA.Data, 2);
      this.$cookie.set('CURLOGINNAME', PARAMS.UserName, 2);
      this.$dialog.alert({
        message: '登录成功！',
      }).then(() => {
        // on close
        // this.$router.replace({path: 'Home', query: {appId: 'wx7dca6b7323e4f055'}});
      });
    } else {
      this.$dialog.alert({
        message: DATA.AllMessages,
      });
    }
  }
}
